module.exports = __webpack_public_path__ + "581f578e.svg";